import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import BasicModal from './Modal';
import AppLogo from './svg/AppLogo';
import styled, { keyframes } from 'styled-components';

import { tada } from 'react-animations';

const tadaAnimation = keyframes`${tada}`;

const SwingDiv = styled.div`
  animation: 1s ${tadaAnimation};
`;  

const sections = ['ABOUT', 'TOKENOMICS', 'HOW TO BUY', 'ROADMAP', 'CONTACT'];

function MenuBar() {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };




  return (
    <AppBar position="relative" sx={{ zIndex: 10, boxShadow: "none"}}>
      <Container maxWidth="xl"  sx={{
          padding: "1rem"
        }}>
        <Toolbar disableGutters>
          <SwingDiv>
            <AppLogo></AppLogo>
          </SwingDiv>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
                fontFamily: "Londrina",
                color: "#fff",
                boxShadow:"none"
              }}
            >
              {sections.map((section) => (
                <MenuItem key={section} onClick={handleCloseNavMenu}>
                  <Typography 
                    variant="h5"
                    component="h2"
                  >
                    <Link href={"#__"+section} underline="none">
                      {section}
                    </Link>
                  </Typography>
                </MenuItem>
              ))}
                <MenuItem onClick={handleCloseNavMenu}>
                  <BasicModal />
                </MenuItem>
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'Londrina',
              fontWeight: 700,
              color: 'inherit',
              textAlign: 'center',
              textDecoration: 'none',
            }}
          >
            <span className='text-highlight' style={{margin:"auto"}}>WASSIE</span>
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              sx={{color:"#fff", margin:"auto"}}
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Box sx={{ flexGrow: 1, pl:1,  display: { xs: 'none', md: 'flex' }, alignItems: "left", justifyContent: "left" }}>
            {/* <div style={{color: 'white', display: 'block', fontSize:"1.5rem", margin:"15px", lineHeight: "2", paddingLeft:4, paddingRight:4, textTransform: "none"}}>
              <Switch {...label} color="secondary"/> Translate
            </div> */}
            {sections.map((section) => (
              <Button
                key={section}
                onClick={handleCloseNavMenu}
                href={"#__"+section}
                className='text-meme'
                sx={{ my: 2, color: 'white', display: 'block', fontSize:"1.5rem", pl:3, pr:2, textAlign:"center", textTransform: "none"}}
              >
                {section}
              </Button>
            ))}

              {/* <Merch />  */}
            </Box>
            <Box sx={{ flexGrow: 1, pl:2,  display: { xs: 'none', md: 'flex' }, alignItems: "right", justifyContent: "right" }}>
              <BasicModal></BasicModal>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default MenuBar;